import { render, staticRenderFns } from "./huawei-brand.vue?vue&type=template&id=11513c6b"
import script from "./huawei-brand.vue?vue&type=script&lang=js"
export * from "./huawei-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports